import { render, staticRenderFns } from "./KnFieldRestSelect.vue?vue&type=template&id=1d964352"
import script from "./KnFieldRestSelect.vue?vue&type=script&lang=js"
export * from "./KnFieldRestSelect.vue?vue&type=script&lang=js"
import style0 from "./KnFieldRestSelect.vue?vue&type=style&index=0&id=1d964352&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports